import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { DateInput } from 'foundations-components/transitional/components/DateInput';
import { TimeInput } from 'foundations-components/transitional/components/TimeInput';
import { MultiColumn, MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { useState } from 'react';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
// @ts-ignore Untyped module
import PageExpiryExternalUrlModal from 'ContentEditorUI/components/settings/PageExpiryExternalUrlModal';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const UnpublishRedirectUrlField = ({
  disabled,
  unpublishExpiryUrl,
  setUnpublishExpiryUrl,
  loadRedirectUrlOptions
}) => {
  const [redirectUrlSearchQuery, setRedirectUrlSearchQuery] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const redirectUrlLoadOptions = (input, callback) => {
    setRedirectUrlSearchQuery(input);
    if (loadRedirectUrlOptions) {
      loadRedirectUrlOptions(input, callback);
      return;
    }
  };
  const redirectUrlSelectedOption = () => {
    // These options are used for the `options` attribute of Select,
    // and are used to provide available options for the selected value
    // before the user types to search. Without these options, the Select
    // could only show the value (which would be the selected expiry URL).
    if (unpublishExpiryUrl) {
      return [{
        text: unpublishExpiryUrl,
        value: unpublishExpiryUrl
      }];
    }
    return [];
  };
  const handleRedirectChange = ({
    target: {
      value
    }
  }) => {
    setUnpublishExpiryUrl(value);
  };
  const handleCreateExternalUrl = (externalUrlPrefix, externalUrlPath) => {
    setUnpublishExpiryUrl(`${externalUrlPrefix}${externalUrlPath}`);
    setModalOpen(false);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "patagoniaPublishingOptionsModal.unpublishRedirect.header"
      }),
      marginBlockStart: "400",
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsx(Select, {
        "data-test-id": "page-expiration-url",
        autoload: true,
        clearable: true,
        defaultValue: unpublishExpiryUrl,
        dropdownFooter: /*#__PURE__*/_jsxs(Button, {
          onClick: () => setModalOpen(true),
          use: "link",
          children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "patagoniaPublishingOptionsModal.unpublishRedirect.externalUrlText"
          })]
        }),
        loadOptions: redirectUrlLoadOptions,
        options: redirectUrlSelectedOption(),
        noResultsText: I18n.text(redirectUrlSearchQuery.length === 0 ? 'patagoniaPublishingOptionsModal.unpublishRedirect.redirectUrlTypeToSearch' : 'patagoniaPublishingOptionsModal.unpublishRedirect.redirectUrlNoResultsFound'),
        onChange: handleRedirectChange,
        placeholder: I18n.text('patagoniaPublishingOptionsModal.unpublishRedirect.redirectUrlPlaceholder'),
        value: unpublishExpiryUrl,
        readOnly: disabled
      })
    }), modalOpen ? /*#__PURE__*/_jsx(PageExpiryExternalUrlModal // TODO: Rename this modal to be more generic
    , {
      closeModal: () => setModalOpen(false),
      onCreateExternalUrl: handleCreateExternalUrl
    }) : null]
  });
};
const SchedulingUnpublishControls = ({
  scheduledUnpublishDate,
  setScheduledUnpublishDate,
  scheduledUnpublishTime,
  setScheduledUnpublishTime,
  isReadOnlyMode,
  onExitSchedulingClick,
  minimumDateForUnpublish,
  minimumTimeForUnpublish,
  unpublishExpiryUrl,
  setUnpublishExpiryUrl,
  unpublishRedirectOptions,
  maxUnpublishDate
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MultiColumn, {
      flush: true,
      children: /*#__PURE__*/_jsxs(MultiColumnGroup, {
        children: [/*#__PURE__*/_jsx(MultiColumnItem, {
          horizontalAlign: "left",
          verticalAlign: "middle",
          paddingInline: "200",
          children: /*#__PURE__*/_jsx(DateInput, {
            "data-test-id": "unpublishing-date-picker",
            min: minimumDateForUnpublish,
            max: maxUnpublishDate,
            onChange: ({
              target: {
                value
              }
            }) => {
              setScheduledUnpublishDate(value);
            },
            value: scheduledUnpublishDate,
            readOnly: isReadOnlyMode
          })
        }), /*#__PURE__*/_jsx(MultiColumnItem, {
          horizontalAlign: "left",
          verticalAlign: "middle",
          paddingInline: "200",
          children: /*#__PURE__*/_jsx(TimeInput, {
            value: scheduledUnpublishTime,
            "data-test-id": "unpublishing-time-picker",
            use: "default",
            onChange: e => {
              setScheduledUnpublishTime(e.target.value);
            },
            readOnly: isReadOnlyMode,
            format: `LT [${I18n.moment.portalTz().format('z')}]`,
            interval: 15,
            min: minimumTimeForUnpublish
          })
        }), /*#__PURE__*/_jsx(MultiColumnItem, {
          horizontalAlign: "right",
          verticalAlign: "middle",
          paddingInline: "200",
          children: /*#__PURE__*/_jsx(IconButton, {
            use: "unstyled",
            onClick: onExitSchedulingClick,
            children: /*#__PURE__*/_jsx(RemoveIcon, {})
          })
        })]
      })
    }), unpublishRedirectOptions !== null && unpublishRedirectOptions !== void 0 && unpublishRedirectOptions.allowRedirectOnUnpublish ? /*#__PURE__*/_jsx(UnpublishRedirectUrlField, {
      disabled: isReadOnlyMode,
      unpublishExpiryUrl: unpublishExpiryUrl,
      setUnpublishExpiryUrl: setUnpublishExpiryUrl,
      loadRedirectUrlOptions: unpublishRedirectOptions === null || unpublishRedirectOptions === void 0 ? void 0 : unpublishRedirectOptions.loadRedirectUrlOptions
    }) : null]
  });
};
export default SchedulingUnpublishControls;